export default __webpack_public_path__ + "static/media/AstronomyJupiter_09.91c5f568.png";